<fgb-account-layout titleKey="account.activity.page.title" titleDefault="Activity">
  <fgb-account-panel titleKey="account.activity.page.title" titleDefault="Activity">
    <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
  </fgb-account-panel>
</fgb-account-layout>
